import { createContext, useContext, useState } from 'react';

const DragContext = createContext();

export function DragProvider({ children, onDrop }) {
  const [draggedItem, setDraggedItem] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const [hoveredSlot, setHoveredSlot] = useState(null);
  const [isCompact, setIsCompact] = useState(false);
  const [initialMousePos, setInitialMousePos] = useState({ x: 0, y: 0 });

  const startDrag = (item, sourceCollectionId, sourceSlotPosition, compact = false, mouseX = 0, mouseY = 0) => {
    setDraggedItem({
      ...item,
      sourceCollectionId,
      sourceSlotPosition
    });
    setIsDragging(true);
    setIsCompact(compact);
    setInitialMousePos({ x: mouseX, y: mouseY });
  };

  const endDrag = () => {
    setDraggedItem(null);
    setIsDragging(false);
    setHoveredSlot(null);
  };

  const setHovered = (slotId) => {
    setHoveredSlot(slotId);
  };

  const handleDrop = async (targetCollectionId, targetSlotPosition) => {
    if (!draggedItem || !onDrop) {
      endDrag();
      return;
    }

    try {
      await onDrop({
        itemId: draggedItem.id,
        sourceCollectionId: draggedItem.sourceCollectionId,
        sourceSlotPosition: draggedItem.sourceSlotPosition,
        targetCollectionId,
        targetSlotPosition
      });
    } catch (error) {
      console.error('Drop failed:', error);
    } finally {
      endDrag();
    }
  };

  return (
    <DragContext.Provider
      value={{
        draggedItem,
        isDragging,
        hoveredSlot,
        isCompact,
        initialMousePos,
        startDrag,
        endDrag,
        setHovered,
        handleDrop,
      }}
    >
      {children}
    </DragContext.Provider>
  );
}

export function useDrag() {
  const context = useContext(DragContext);
  if (!context) {
    throw new Error('useDrag must be used within a DragProvider');
  }
  return context;
}
